'use strict';

var toggleVisibility = function(event) {
  event.preventDefault();
  var expandedContent = event.target.previousElementSibling;
  if (!expandedContent || !expandedContent.classList.contains("expanded")) {
    return;
  }

  if (expandedContent.style.display == 'block') {
    expandedContent.classList.remove('animated', 'slideInUp');
    expandedContent.classList.add('animated', 'slideOutDown');
    expandedContent.style.display = 'none';
    event.target.innerHTML = 'Read More';
  } else {
    expandedContent.classList.remove('animated', 'slideOutDown');
    expandedContent.classList.add('animated', 'slideInUp');
    expandedContent.style.display = 'block';
    event.target.innerHTML = 'Collapse';
  }
};

var aboutSection = document.getElementsByClassName('about')[0];

aboutSection.addEventListener('click', toggleVisibility);
